'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.yDomain = yDomain;

var _d3Interop = require('./d3Interop');

function yDomain(props, stack, horizonal) {
  var data = props.data,
    chartSeries = props.chartSeries,
    y = props.y,
    yDomainProp = props.yDomain,
    yScale = props.yScale;

  if (yDomainProp) return yDomainProp;

  if (!horizonal) {
    if (stack) {
      var max = 0;
      var min = 0;

      data.forEach(function (d) {
        var totalTop = 0;
        var totalBottom = 0;

        chartSeries.forEach(function (sd) {
          var field = sd.field;

          if (d[field] > 0) {
            totalTop += y(d[field]);
          } else if (d[field] < 0) {
            totalBottom += y(d[field]);
          }
        });

        if (totalTop > max) max = totalTop;
        if (totalBottom < min) min = totalBottom;
      });

      return [min, max];
    }

    var domainArr = chartSeries.map(function (d) {
      var field = d.field;
      return _d3Interop.d3Array.extent(data, function (dt) {
        return y(dt[field]);
      });
    });

    var extentArr = _d3Interop.d3Array.extent([].concat.apply([], domainArr));

    if (extentArr[0] * extentArr[1] >= 0) {
      return [0, extentArr[1]];
    }
    return extentArr;
  }

  if (yScale === 'ordinal') {
    return data.map(function (d) {
      return y(d);
    });
  }
  return _d3Interop.d3Array.extent(data, function (d) {
    return y(d);
  });
}
